import type { MagazineAnalyticsSettingFormModel } from "../../../../model/type";

type Props = {
	viewModel: MagazineAnalyticsSettingFormModel["ViewModel"];
};

export const useDesignMagazineAnalyticsSetting = ({ viewModel }: Props) => {
	const isValid = viewModel.isDirty && !viewModel.hasError;

	return {
		isValid,
	};
};
